<template>
  <section class="product-financing" id="financing-service">
    <div class="section-inner">
      <div class="content-wrapper">
        <div class="image-content fade-in-section">
          <img
            :src="productImage"
            :alt="t('home.financing.title')"
            class="product-image"
          />
        </div>

        <div class="text-content">
          <p class="section-label fade-in-section">{{ t('home.financing.label') }}</p>
          <h2 class="section-title fade-in-section">{{ t('home.financing.title') }}</h2>
          <p class="section-subtitle fade-in-section">{{ t('home.financing.subtitle') }}</p>
          <p class="section-description fade-in-section">{{ t('home.financing.description') }}</p>

          <div class="license-row fade-in-section">
            <span class="license-label">{{ t('home.financing.licenseLabel') }}</span>
            <strong class="license-number">{{ t('home.financing.licenseNumber') }}</strong>
          </div>

          <ul class="feature-list">
            <li
              v-for="featureKey in featureKeys"
              :key="featureKey"
              class="feature-item fade-in-section"
            >
              <span class="feature-dot" aria-hidden="true"></span>
              <span>{{ t(`home.financing.features.${featureKey}`) }}</span>
            </li>
          </ul>

          <aside class="warning-box fade-in-section" role="note" aria-label="Money lender warning">
            <p class="warning-text">{{ t('home.financing.warning') }}</p>
          </aside>

          <div class="action-row fade-in-section">
            <a class="btn btn-primary" href="/#contact-us">
              {{ t('home.financing.cta') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'

const productImage = require('@/assets/img/home/product-financing.png')

export default {
  name: 'ProductFinancing',
  setup() {
    const { t } = useTranslation()
    const featureKeys = ['feature1', 'feature2', 'feature3']

    return {
      t,
      productImage,
      featureKeys
    }
  }
}
</script>

<style lang="scss" scoped>
.product-financing {
  padding: 96px 20px;
  background: #f7f9fc;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 48px;
  align-items: center;
}

.section-label {
  margin: 0 0 12px;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #1a7fb0;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-title {
  margin: 0 0 16px;
  font-size: clamp(24px, 3vw, 34px);
  line-height: 1.25;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.section-subtitle {
  margin: 0 0 12px;
  font-size: 16px;
  line-height: 1.7;
  color: #4a6075;
  font-family: 'Aileron-Regular', sans-serif;
}

.section-description {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.7;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

.license-row {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin: 0 0 24px;
  padding: 10px 16px;
  border: 1px solid rgba(15, 76, 129, 0.2);
  border-radius: 8px;
  background: #ffffff;
}

.license-label {
  font-size: 13px;
  color: #4a6075;
  font-family: 'Aileron-Regular', sans-serif;
}

.license-number {
  font-size: 16px;
  letter-spacing: 0.04em;
  color: #0f4c81;
  font-family: 'Aileron-Bold', sans-serif;
}

.feature-list {
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.feature-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.65;
  color: #52667a;
  font-family: 'Aileron-Regular', sans-serif;
}

.feature-dot {
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 50%;
  background: #0f4c81;
  flex-shrink: 0;
}

.warning-box {
  margin: 0 0 28px;
  padding: 16px 18px;
  border-left: 4px solid #0f4c81;
  background: #ffffff;
}

.warning-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #0b2238;
  font-family: 'Aileron-Bold', sans-serif;
}

.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.25s ease;
  font-family: 'Aileron-Bold', sans-serif;
}

.btn-primary {
  background: linear-gradient(135deg, #1a7fb0 0%, #0f4c81 100%);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 76, 129, 0.2);
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2196c4 0%, #125a94 100%);
  box-shadow: 0 12px 24px rgba(15, 76, 129, 0.28);
}

.product-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  object-position: center;
  border-radius: 12px;
}

@media (max-width: 900px) {
  .content-wrapper {
    grid-template-columns: 1fr;
  }

  .image-content {
    order: -1;
  }

  .btn {
    width: 100%;
  }
}
</style>
